import {
    animate,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";
import {
    AfterViewInit,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from "@angular/core";
import {
    NgbAccordionConfig,
    NgbModal
} from "@ng-bootstrap/ng-bootstrap";
import { NavigationService } from "src/app/navigation/navigation.service";
import releaseNotesCurrent from "../../../assets/releaseNotes/releaseNotes.json";
import releaseNotesLocalized from "../../../assets/releaseNotes/releaseNotesTranslation.json";
import { ReleaseModalService } from "./release-modal.service";

@Component({
    selector: "release-modal",
    templateUrl: "./release-modal.component.html",
    styleUrls: ["./release-modal.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger("rotateIcon", [
            state(
                "false",
                style({
                    transform: "rotate(0deg)",
                })
            ),
            state(
                "true",
                style({
                    transform: "rotate(90deg)",
                })
            ),
            transition("true => false", animate(".2s")),
            transition("false => true", animate(".2s")),
        ]),
    ],
})
export class ReleaseModalComponent implements OnInit, OnChanges, AfterViewInit {
    stringifiedReleaseData: any;
    parsedJson: any;
    @Input() releaseNotes: any;
    @Input() releaseNotesLocal: any;
    releaseNotesCurrent: Promise<string> | null = null;
    releasNotesLocalized: Promise<string> | null = null;
    content: any;
    close: any;
    @ViewChild("releaseNotesModal") releaseNotesModal: TemplateRef<any>;
    @Input() notification: any;
    state: boolean;
    style: any;
    trigger: any;
    panelOpen = false;
    response: number;
    companyPackage: number;
    packageFilter: any;
    returnedHeaders: Set<string>;
    partnerId: string;
    partnerName: string;
    stringifiedReleaseDataLocal: string;
    parsedJsonLocal: any;
    packageDisplayFilter: any;
    greetings = "Here's what to expect from";
    acknowledge = "Thanks";
    showNotification: boolean;
    loginId: number;
    notificationId: string;
    notificationName: string;
    viewedNotification: boolean;

    constructor(
        private modalService: NgbModal,
        private config: NgbAccordionConfig,
        private releaseModalService: ReleaseModalService,
        private navigationService: NavigationService
    ) {
        this.releaseNotes = releaseNotesCurrent;
        this.releaseNotesLocal = releaseNotesLocalized;
        config.animation = true;
    }

    animatePanel(i) {
        this.packageDisplayFilter[i].animation =
            !this.packageDisplayFilter[i].animation;
    }

    //get company packages and filter accordion headers with that list
    async partnerPackage() {
        const companyPackage =
            await this.releaseModalService.partnerSalesPackage();
        //create new list of headers that match packages a company has.
        const returnedHeaders = new Set(companyPackage.map((p) => p.PackageName));
        const packageName = this.releaseNotes.headers;
        this.packageFilter = packageName.filter(
            (p) =>
                returnedHeaders.has(p) &&
                releaseNotesCurrent.Notes[p] &&
                releaseNotesCurrent.Notes[p].length > 0
        );
        //generate english header names for style purposes.
        const returnedDisplayHeaders = new Set(
            companyPackage.map((p) => p.PackageName)
        );
        const packageDisplayName = releaseNotesCurrent.displayHeaders;
        this.packageDisplayFilter = packageDisplayName.filter(
            (p) =>
                returnedDisplayHeaders.has(p) &&
                releaseNotesCurrent.Notes[p] &&
                releaseNotesCurrent.Notes[p].length > 0
        );
        for (let i = 0; i < this.packageDisplayFilter.length; i++) {
            this.packageDisplayFilter[i] = {
                name: this.packageDisplayFilter[i],
                animation: false,
            };
        }
    }

    //get partnerId and localize package notes
    async showPartnerPackages() {
        const response = await this.releaseModalService.partnerID();
        let partnerId = null;
        const userLang = this.navigationService.loggedInLang;

        switch (userLang) {
            case "English":
                break;
            case "Español":
                this.greetings = this.releaseNotesLocal.Spanish.Greetings;
                this.acknowledge = this.releaseNotesLocal.Spanish.acknowledge;
                this.releaseNotes.releaseVersion =
                    this.releaseNotesLocal.Spanish.releaseVersion;
                //RegularNotes
                this.releaseNotes.Notes.General =
                    this.releaseNotesLocal.Spanish.Notes.General;
                this.releaseNotes.Notes.Messaging =
                    this.releaseNotesLocal.Spanish.Notes.Messaging;
                this.releaseNotes.Notes.Gamification =
                    this.releaseNotesLocal.Spanish.Notes.Gamification;
                this.releaseNotes.Notes.Coaching =
                    this.releaseNotesLocal.Spanish.Notes.Coaching;
                this.releaseNotes.Notes.QA =
                    this.releaseNotesLocal.Spanish.Notes.QA;
                this.releaseNotes.Notes.Dashboards =
                    this.releaseNotesLocal.Spanish.Notes.Dashboards;
                this.releaseNotes.Notes.Wallboards =
                    this.releaseNotesLocal.Spanish.Notes.Wallboards;
                //PartnerNotes
                //Direct
                this.releaseNotes.DirectNotes.General =
                    this.releaseNotesLocal.Spanish.DirectNotes.General;
                this.releaseNotes.DirectNotes.Messaging =
                    this.releaseNotesLocal.Spanish.DirectNotes.Messaging;
                this.releaseNotes.DirectNotes.Gamification =
                    this.releaseNotesLocal.Spanish.DirectNotes.Gamification;
                this.releaseNotes.DirectNotes.Coaching =
                    this.releaseNotesLocal.Spanish.DirectNotes.Coaching;
                this.releaseNotes.DirectNotes.QA =
                    this.releaseNotesLocal.Spanish.DirectNotes.QA;
                this.releaseNotes.DirectNotes.Dashboards =
                    this.releaseNotesLocal.Spanish.DirectNotes.Dashboards;
                this.releaseNotes.DirectNotes.Wallboards =
                    this.releaseNotesLocal.Spanish.DirectNotes.Wallboards;
                //NiceInContact
                this.releaseNotes.NiceInContactNotes.General =
                    this.releaseNotesLocal.Spanish.NiceInContactNotes.General;
                this.releaseNotes.NiceInContactNotes.Messaging =
                    this.releaseNotesLocal.Spanish.NiceInContactNotes.Messaging;
                this.releaseNotes.NiceInContactNotes.Gamification =
                    this.releaseNotesLocal.Spanish.NiceInContactNotes.Gamification;
                this.releaseNotes.NiceInContactNotes.Coaching =
                    this.releaseNotesLocal.Spanish.NiceInContactNotes.Coaching;
                this.releaseNotes.NiceInContactNotes.QA =
                    this.releaseNotesLocal.Spanish.NiceInContactNotes.QA;
                this.releaseNotes.NiceInContactNotes.Dashboards =
                    this.releaseNotesLocal.Spanish.NiceInContactNotes.Dashboards;
                this.releaseNotes.NiceInContactNotes.Wallboards =
                    this.releaseNotesLocal.Spanish.NiceInContactNotes.Wallboards;
                //Five9
                this.releaseNotes.Five9Notes.General =
                    this.releaseNotesLocal.Spanish.Five9Notes.General;
                this.releaseNotes.Five9Notes.Messaging =
                    this.releaseNotesLocal.Spanish.Five9Notes.Messaging;
                this.releaseNotes.Five9Notes.Gamification =
                    this.releaseNotesLocal.Spanish.Five9Notes.Gamification;
                this.releaseNotes.Five9Notes.Coaching =
                    this.releaseNotesLocal.Spanish.Five9Notes.Coaching;
                this.releaseNotes.Five9Notes.QA =
                    this.releaseNotesLocal.Spanish.Five9Notes.QA;
                this.releaseNotes.Five9Notes.Dashboards =
                    this.releaseNotesLocal.Spanish.Five9Notes.Dashboards;
                this.releaseNotes.Five9Notes.Wallboards =
                    this.releaseNotesLocal.Spanish.Five9Notes.Wallboards;
                //Serenova
                this.releaseNotes.SerenovaNotes.General =
                    this.releaseNotesLocal.Spanish.SerenovaNotes.General;
                this.releaseNotes.SerenovaNotes.Messaging =
                    this.releaseNotesLocal.Spanish.SerenovaNotes.Messaging;
                this.releaseNotes.SerenovaNotes.Gamification =
                    this.releaseNotesLocal.Spanish.SerenovaNotes.Gamification;
                this.releaseNotes.SerenovaNotes.Coaching =
                    this.releaseNotesLocal.Spanish.SerenovaNotes.Coaching;
                this.releaseNotes.SerenovaNotes.QA =
                    this.releaseNotesLocal.Spanish.SerenovaNotes.QA;
                this.releaseNotes.SerenovaNotes.Dashboards =
                    this.releaseNotesLocal.Spanish.SerenovaNotes.Dashboards;
                this.releaseNotes.SerenovaNotes.Wallboards =
                    this.releaseNotesLocal.Spanish.SerenovaNotes.Wallboards;
                //Genesys
                this.releaseNotes.GenesysNotes.General =
                    this.releaseNotesLocal.Spanish.GenesysNotes.General;
                this.releaseNotes.GenesysNotes.Messaging =
                    this.releaseNotesLocal.Spanish.GenesysNotes.Messaging;
                this.releaseNotes.GenesysNotes.Gamification =
                    this.releaseNotesLocal.Spanish.GenesysNotes.Gamification;
                this.releaseNotes.GenesysNotes.Coaching =
                    this.releaseNotesLocal.Spanish.GenesysNotes.Coaching;
                this.releaseNotes.GenesysNotes.QA =
                    this.releaseNotesLocal.Spanish.GenesysNotes.QA;
                this.releaseNotes.GenesysNotes.Dashboards =
                    this.releaseNotesLocal.Spanish.GenesysNotes.Dashboards;
                this.releaseNotes.GenesysNotes.Wallboards =
                    this.releaseNotesLocal.Spanish.GenesysNotes.Wallboards;
                //Cisco
                this.releaseNotes.CiscoNotes.General =
                    this.releaseNotesLocal.Spanish.CiscoNotes.General;
                this.releaseNotes.CiscoNotes.Messaging =
                    this.releaseNotesLocal.Spanish.CiscoNotes.Messaging;
                this.releaseNotes.CiscoNotes.Gamification =
                    this.releaseNotesLocal.Spanish.CiscoNotes.Gamification;
                this.releaseNotes.CiscoNotes.Coaching =
                    this.releaseNotesLocal.Spanish.CiscoNotes.Coaching;
                this.releaseNotes.CiscoNotes.QA =
                    this.releaseNotesLocal.Spanish.CiscoNotes.QA;
                this.releaseNotes.CiscoNotes.Dashboards =
                    this.releaseNotesLocal.Spanish.CiscoNotes.Dashboards;
                this.releaseNotes.CiscoNotes.Wallboards =
                    this.releaseNotesLocal.Spanish.CiscoNotes.Wallboards;
                //Amazon
                this.releaseNotes.AmazonNotes.General =
                    this.releaseNotesLocal.Spanish.AmazonNotes.General;
                this.releaseNotes.AmazonNotes.Messaging =
                    this.releaseNotesLocal.Spanish.AmazonNotes.Messaging;
                this.releaseNotes.AmazonNotes.Gamification =
                    this.releaseNotesLocal.Spanish.AmazonNotes.Gamification;
                this.releaseNotes.AmazonNotes.Coaching =
                    this.releaseNotesLocal.Spanish.AmazonNotes.Coaching;
                this.releaseNotes.AmazonNotes.QA =
                    this.releaseNotesLocal.Spanish.AmazonNotes.QA;
                this.releaseNotes.AmazonNotes.Dashboards =
                    this.releaseNotesLocal.Spanish.AmazonNotes.Dashboards;
                this.releaseNotes.AmazonNotes.Wallboards =
                    this.releaseNotesLocal.Spanish.AmazonNotes.Wallboards;
                //Avaya
                this.releaseNotes.AvayaNotes.General =
                    this.releaseNotesLocal.Spanish.AvayaNotes.General;
                this.releaseNotes.AvayaNotes.Messaging =
                    this.releaseNotesLocal.Spanish.AvayaNotes.Messaging;
                this.releaseNotes.AvayaNotes.Gamification =
                    this.releaseNotesLocal.Spanish.AvayaNotes.Gamification;
                this.releaseNotes.AvayaNotes.Coaching =
                    this.releaseNotesLocal.Spanish.AvayaNotes.Coaching;
                this.releaseNotes.AvayaNotes.QA =
                    this.releaseNotesLocal.Spanish.AvayaNotes.QA;
                this.releaseNotes.AvayaNotes.Dashboards =
                    this.releaseNotesLocal.Spanish.AvayaNotes.Dashboards;
                this.releaseNotes.AvayaNotes.Wallboards =
                    this.releaseNotesLocal.Spanish.AvayaNotes.Wallboards;
                //UJet
                this.releaseNotes.UJetNotes.General =
                    this.releaseNotesLocal.Spanish.UJetNotes.General;
                this.releaseNotes.UJetNotes.Messaging =
                    this.releaseNotesLocal.Spanish.UJetNotes.Messaging;
                this.releaseNotes.UJetNotes.Gamification =
                    this.releaseNotesLocal.Spanish.UJetNotes.Gamification;
                this.releaseNotes.UJetNotes.Coaching =
                    this.releaseNotesLocal.Spanish.UJetNotes.Coaching;
                this.releaseNotes.UJetNotes.QA =
                    this.releaseNotesLocal.Spanish.UJetNotes.QA;
                this.releaseNotes.UJetNotes.Dashboards =
                    this.releaseNotesLocal.Spanish.UJetNotes.Dashboards;
                this.releaseNotes.UJetNotes.Wallboards =
                    this.releaseNotesLocal.Spanish.UJetNotes.Wallboards;
                break;

            case "Français":
                this.greetings = this.releaseNotesLocal.French.Greetings;
                this.acknowledge = this.releaseNotesLocal.French.acknowledge;
                this.releaseNotes.releaseVersion =
                    this.releaseNotesLocal.French.releaseVersion;

                //RegularNotes
                this.releaseNotes.Notes.General =
                    this.releaseNotesLocal.French.Notes.General;
                this.releaseNotes.Notes.Messaging =
                    this.releaseNotesLocal.French.Notes.Messaging;
                this.releaseNotes.Notes.Gamification =
                    this.releaseNotesLocal.French.Notes.Gamification;
                this.releaseNotes.Notes.Coaching =
                    this.releaseNotesLocal.French.Notes.Coaching;
                this.releaseNotes.Notes.QA =
                    this.releaseNotesLocal.French.Notes.QA;
                this.releaseNotes.Notes.Dashboards =
                    this.releaseNotesLocal.French.Notes.Dashboards;
                this.releaseNotes.Notes.Wallboards =
                    this.releaseNotesLocal.French.Notes.Wallboards;
                //PartnerNotes
                //Direct
                this.releaseNotes.DirectNotes.General =
                    this.releaseNotesLocal.French.DirectNotes.General;
                this.releaseNotes.DirectNotes.Messaging =
                    this.releaseNotesLocal.French.DirectNotes.Messaging;
                this.releaseNotes.DirectNotes.Gamification =
                    this.releaseNotesLocal.French.DirectNotes.Gamification;
                this.releaseNotes.DirectNotes.Coaching =
                    this.releaseNotesLocal.French.DirectNotes.Coaching;
                this.releaseNotes.DirectNotes.QA =
                    this.releaseNotesLocal.French.DirectNotes.QA;
                this.releaseNotes.DirectNotes.Dashboards =
                    this.releaseNotesLocal.French.DirectNotes.Dashboards;
                this.releaseNotes.DirectNotes.Wallboards =
                    this.releaseNotesLocal.French.DirectNotes.Wallboards;
                //NiceInContact
                this.releaseNotes.NiceInContactNotes.General =
                    this.releaseNotesLocal.French.NiceInContactNotes.General;
                this.releaseNotes.NiceInContactNotes.Messaging =
                    this.releaseNotesLocal.French.NiceInContactNotes.Messaging;
                this.releaseNotes.NiceInContactNotes.Gamification =
                    this.releaseNotesLocal.French.NiceInContactNotes.Gamification;
                this.releaseNotes.NiceInContactNotes.Coaching =
                    this.releaseNotesLocal.French.NiceInContactNotes.Coaching;
                this.releaseNotes.NiceInContactNotes.QA =
                    this.releaseNotesLocal.French.NiceInContactNotes.QA;
                this.releaseNotes.NiceInContactNotes.Dashboards =
                    this.releaseNotesLocal.French.NiceInContactNotes.Dashboards;
                this.releaseNotes.NiceInContactNotes.Wallboards =
                    this.releaseNotesLocal.French.NiceInContactNotes.Wallboards;
                //Five9
                this.releaseNotes.Five9Notes.General =
                    this.releaseNotesLocal.French.Five9Notes.General;
                this.releaseNotes.Five9Notes.Messaging =
                    this.releaseNotesLocal.French.Five9Notes.Messaging;
                this.releaseNotes.Five9Notes.Gamification =
                    this.releaseNotesLocal.French.Five9Notes.Gamification;
                this.releaseNotes.Five9Notes.Coaching =
                    this.releaseNotesLocal.French.Five9Notes.Coaching;
                this.releaseNotes.Five9Notes.QA =
                    this.releaseNotesLocal.French.Five9Notes.QA;
                this.releaseNotes.Five9Notes.Dashboards =
                    this.releaseNotesLocal.French.Five9Notes.Dashboards;
                this.releaseNotes.Five9Notes.Wallboards =
                    this.releaseNotesLocal.French.Five9Notes.Wallboards;
                //Serenova
                this.releaseNotes.SerenovaNotes.General =
                    this.releaseNotesLocal.French.SerenovaNotes.General;
                this.releaseNotes.SerenovaNotes.Messaging =
                    this.releaseNotesLocal.French.SerenovaNotes.Messaging;
                this.releaseNotes.SerenovaNotes.Gamification =
                    this.releaseNotesLocal.French.SerenovaNotes.Gamification;
                this.releaseNotes.SerenovaNotes.Coaching =
                    this.releaseNotesLocal.French.SerenovaNotes.Coaching;
                this.releaseNotes.SerenovaNotes.QA =
                    this.releaseNotesLocal.French.SerenovaNotes.QA;
                this.releaseNotes.SerenovaNotes.Dashboards =
                    this.releaseNotesLocal.French.SerenovaNotes.Dashboards;
                this.releaseNotes.SerenovaNotes.Wallboards =
                    this.releaseNotesLocal.French.SerenovaNotes.Wallboards;
                //Genesys
                this.releaseNotes.GenesysNotes.General =
                    this.releaseNotesLocal.French.GenesysNotes.General;
                this.releaseNotes.GenesysNotes.Messaging =
                    this.releaseNotesLocal.French.GenesysNotes.Messaging;
                this.releaseNotes.GenesysNotes.Gamification =
                    this.releaseNotesLocal.French.GenesysNotes.Gamification;
                this.releaseNotes.GenesysNotes.Coaching =
                    this.releaseNotesLocal.French.GenesysNotes.Coaching;
                this.releaseNotes.GenesysNotes.QA =
                    this.releaseNotesLocal.French.GenesysNotes.QA;
                this.releaseNotes.GenesysNotes.Dashboards =
                    this.releaseNotesLocal.French.GenesysNotes.Dashboards;
                this.releaseNotes.GenesysNotes.Wallboards =
                    this.releaseNotesLocal.French.GenesysNotes.Wallboards;
                //Cisco
                this.releaseNotes.CiscoNotes.General =
                    this.releaseNotesLocal.French.CiscoNotes.General;
                this.releaseNotes.CiscoNotes.Messaging =
                    this.releaseNotesLocal.French.CiscoNotes.Messaging;
                this.releaseNotes.CiscoNotes.Gamification =
                    this.releaseNotesLocal.French.CiscoNotes.Gamification;
                this.releaseNotes.CiscoNotes.Coaching =
                    this.releaseNotesLocal.French.CiscoNotes.Coaching;
                this.releaseNotes.CiscoNotes.QA =
                    this.releaseNotesLocal.French.CiscoNotes.QA;
                this.releaseNotes.CiscoNotes.Dashboards =
                    this.releaseNotesLocal.French.CiscoNotes.Dashboards;
                this.releaseNotes.CiscoNotes.Wallboards =
                    this.releaseNotesLocal.French.CiscoNotes.Wallboards;
                //Amazon
                this.releaseNotes.AmazonNotes.General =
                    this.releaseNotesLocal.French.AmazonNotes.General;
                this.releaseNotes.AmazonNotes.Messaging =
                    this.releaseNotesLocal.French.AmazonNotes.Messaging;
                this.releaseNotes.AmazonNotes.Gamification =
                    this.releaseNotesLocal.French.AmazonNotes.Gamification;
                this.releaseNotes.AmazonNotes.Coaching =
                    this.releaseNotesLocal.French.AmazonNotes.Coaching;
                this.releaseNotes.AmazonNotes.QA =
                    this.releaseNotesLocal.French.AmazonNotes.QA;
                this.releaseNotes.AmazonNotes.Dashboards =
                    this.releaseNotesLocal.French.AmazonNotes.Dashboards;
                this.releaseNotes.AmazonNotes.Wallboards =
                    this.releaseNotesLocal.French.AmazonNotes.Wallboards;
                //Avaya
                this.releaseNotes.AvayaNotes.General =
                    this.releaseNotesLocal.French.AvayaNotes.General;
                this.releaseNotes.AvayaNotes.Messaging =
                    this.releaseNotesLocal.French.AvayaNotes.Messaging;
                this.releaseNotes.AvayaNotes.Gamification =
                    this.releaseNotesLocal.French.AvayaNotes.Gamification;
                this.releaseNotes.AvayaNotes.Coaching =
                    this.releaseNotesLocal.French.AvayaNotes.Coaching;
                this.releaseNotes.AvayaNotes.QA =
                    this.releaseNotesLocal.French.AvayaNotes.QA;
                this.releaseNotes.AvayaNotes.Dashboards =
                    this.releaseNotesLocal.French.AvayaNotes.Dashboards;
                this.releaseNotes.AvayaNotes.Wallboards =
                    this.releaseNotesLocal.French.AvayaNotes.Wallboards;
                //UJet
                this.releaseNotes.UJetNotes.General =
                    this.releaseNotesLocal.French.UJetNotes.General;
                this.releaseNotes.UJetNotes.Messaging =
                    this.releaseNotesLocal.French.UJetNotes.Messaging;
                this.releaseNotes.UJetNotes.Gamification =
                    this.releaseNotesLocal.French.UJetNotes.Gamification;
                this.releaseNotes.UJetNotes.Coaching =
                    this.releaseNotesLocal.French.UJetNotes.Coaching;
                this.releaseNotes.UJetNotes.QA =
                    this.releaseNotesLocal.French.UJetNotes.QA;
                this.releaseNotes.UJetNotes.Dashboards =
                    this.releaseNotesLocal.French.UJetNotes.Dashboards;
                this.releaseNotes.UJetNotes.Wallboards =
                    this.releaseNotesLocal.French.UJetNotes.Wallboards;
                break;

            case "Deutsch":
                this.greetings = this.releaseNotesLocal.German.Greetings;
                this.acknowledge = this.releaseNotesLocal.German.acknowledge;
                this.releaseNotes.releaseVersion =
                    this.releaseNotesLocal.German.releaseVersion;

                //RegularNotes
                this.releaseNotes.Notes.General =
                    this.releaseNotesLocal.German.Notes.General;
                this.releaseNotes.Notes.Messaging =
                    this.releaseNotesLocal.German.Notes.Messaging;
                this.releaseNotes.Notes.Gamification =
                    this.releaseNotesLocal.German.Notes.Gamification;
                this.releaseNotes.Notes.Coaching =
                    this.releaseNotesLocal.German.Notes.Coaching;
                this.releaseNotes.Notes.QA =
                    this.releaseNotesLocal.German.Notes.QA;
                this.releaseNotes.Notes.Dashboards =
                    this.releaseNotesLocal.German.Notes.Dashboards;
                this.releaseNotes.Notes.Wallboards =
                    this.releaseNotesLocal.German.Notes.Wallboards;
                //PartnerNotes
                //Direct
                this.releaseNotes.DirectNotes.General =
                    this.releaseNotesLocal.German.DirectNotes.General;
                this.releaseNotes.DirectNotes.Messaging =
                    this.releaseNotesLocal.German.DirectNotes.Messaging;
                this.releaseNotes.DirectNotes.Gamification =
                    this.releaseNotesLocal.German.DirectNotes.Gamification;
                this.releaseNotes.DirectNotes.Coaching =
                    this.releaseNotesLocal.German.DirectNotes.Coaching;
                this.releaseNotes.DirectNotes.QA =
                    this.releaseNotesLocal.German.DirectNotes.QA;
                this.releaseNotes.DirectNotes.Dashboards =
                    this.releaseNotesLocal.German.DirectNotes.Dashboards;
                this.releaseNotes.DirectNotes.Wallboards =
                    this.releaseNotesLocal.German.DirectNotes.Wallboards;
                //NiceInContact
                this.releaseNotes.NiceInContactNotes.General =
                    this.releaseNotesLocal.German.NiceInContactNotes.General;
                this.releaseNotes.NiceInContactNotes.Messaging =
                    this.releaseNotesLocal.German.NiceInContactNotes.Messaging;
                this.releaseNotes.NiceInContactNotes.Gamification =
                    this.releaseNotesLocal.German.NiceInContactNotes.Gamification;
                this.releaseNotes.NiceInContactNotes.Coaching =
                    this.releaseNotesLocal.German.NiceInContactNotes.Coaching;
                this.releaseNotes.NiceInContactNotes.QA =
                    this.releaseNotesLocal.German.NiceInContactNotes.QA;
                this.releaseNotes.NiceInContactNotes.Dashboards =
                    this.releaseNotesLocal.German.NiceInContactNotes.Dashboards;
                this.releaseNotes.NiceInContactNotes.Wallboards =
                    this.releaseNotesLocal.German.NiceInContactNotes.Wallboards;
                //Five9
                this.releaseNotes.Five9Notes.General =
                    this.releaseNotesLocal.German.Five9Notes.General;
                this.releaseNotes.Five9Notes.Messaging =
                    this.releaseNotesLocal.German.Five9Notes.Messaging;
                this.releaseNotes.Five9Notes.Gamification =
                    this.releaseNotesLocal.German.Five9Notes.Gamification;
                this.releaseNotes.Five9Notes.Coaching =
                    this.releaseNotesLocal.German.Five9Notes.Coaching;
                this.releaseNotes.Five9Notes.QA =
                    this.releaseNotesLocal.German.Five9Notes.QA;
                this.releaseNotes.Five9Notes.Dashboards =
                    this.releaseNotesLocal.German.Five9Notes.Dashboards;
                this.releaseNotes.Five9Notes.Wallboards =
                    this.releaseNotesLocal.German.Five9Notes.Wallboards;
                //Serenova
                this.releaseNotes.SerenovaNotes.General =
                    this.releaseNotesLocal.German.SerenovaNotes.General;
                this.releaseNotes.SerenovaNotes.Messaging =
                    this.releaseNotesLocal.German.SerenovaNotes.Messaging;
                this.releaseNotes.SerenovaNotes.Gamification =
                    this.releaseNotesLocal.German.SerenovaNotes.Gamification;
                this.releaseNotes.SerenovaNotes.Coaching =
                    this.releaseNotesLocal.German.SerenovaNotes.Coaching;
                this.releaseNotes.SerenovaNotes.QA =
                    this.releaseNotesLocal.German.SerenovaNotes.QA;
                this.releaseNotes.SerenovaNotes.Dashboards =
                    this.releaseNotesLocal.German.SerenovaNotes.Dashboards;
                this.releaseNotes.SerenovaNotes.Wallboards =
                    this.releaseNotesLocal.German.SerenovaNotes.Wallboards;
                //Genesys
                this.releaseNotes.GenesysNotes.General =
                    this.releaseNotesLocal.German.GenesysNotes.General;
                this.releaseNotes.GenesysNotes.Messaging =
                    this.releaseNotesLocal.German.GenesysNotes.Messaging;
                this.releaseNotes.GenesysNotes.Gamification =
                    this.releaseNotesLocal.German.GenesysNotes.Gamification;
                this.releaseNotes.GenesysNotes.Coaching =
                    this.releaseNotesLocal.German.GenesysNotes.Coaching;
                this.releaseNotes.GenesysNotes.QA =
                    this.releaseNotesLocal.German.GenesysNotes.QA;
                this.releaseNotes.GenesysNotes.Dashboards =
                    this.releaseNotesLocal.German.GenesysNotes.Dashboards;
                this.releaseNotes.GenesysNotes.Wallboards =
                    this.releaseNotesLocal.German.GenesysNotes.Wallboards;
                //Cisco
                this.releaseNotes.CiscoNotes.General =
                    this.releaseNotesLocal.German.CiscoNotes.General;
                this.releaseNotes.CiscoNotes.Messaging =
                    this.releaseNotesLocal.German.CiscoNotes.Messaging;
                this.releaseNotes.CiscoNotes.Gamification =
                    this.releaseNotesLocal.German.CiscoNotes.Gamification;
                this.releaseNotes.CiscoNotes.Coaching =
                    this.releaseNotesLocal.German.CiscoNotes.Coaching;
                this.releaseNotes.CiscoNotes.QA =
                    this.releaseNotesLocal.German.CiscoNotes.QA;
                this.releaseNotes.CiscoNotes.Dashboards =
                    this.releaseNotesLocal.German.CiscoNotes.Dashboards;
                this.releaseNotes.CiscoNotes.Wallboards =
                    this.releaseNotesLocal.German.CiscoNotes.Wallboards;
                //Amazon
                this.releaseNotes.AmazonNotes.General =
                    this.releaseNotesLocal.German.AmazonNotes.General;
                this.releaseNotes.AmazonNotes.Messaging =
                    this.releaseNotesLocal.German.AmazonNotes.Messaging;
                this.releaseNotes.AmazonNotes.Gamification =
                    this.releaseNotesLocal.German.AmazonNotes.Gamification;
                this.releaseNotes.AmazonNotes.Coaching =
                    this.releaseNotesLocal.German.AmazonNotes.Coaching;
                this.releaseNotes.AmazonNotes.QA =
                    this.releaseNotesLocal.German.AmazonNotes.QA;
                this.releaseNotes.AmazonNotes.Dashboards =
                    this.releaseNotesLocal.German.AmazonNotes.Dashboards;
                this.releaseNotes.AmazonNotes.Wallboards =
                    this.releaseNotesLocal.German.AmazonNotes.Wallboards;
                //Avaya
                this.releaseNotes.AvayaNotes.General =
                    this.releaseNotesLocal.German.AvayaNotes.General;
                this.releaseNotes.AvayaNotes.Messaging =
                    this.releaseNotesLocal.German.AvayaNotes.Messaging;
                this.releaseNotes.AvayaNotes.Gamification =
                    this.releaseNotesLocal.German.AvayaNotes.Gamification;
                this.releaseNotes.AvayaNotes.Coaching =
                    this.releaseNotesLocal.German.AvayaNotes.Coaching;
                this.releaseNotes.AvayaNotes.QA =
                    this.releaseNotesLocal.German.AvayaNotes.QA;
                this.releaseNotes.AvayaNotes.Dashboards =
                    this.releaseNotesLocal.German.AvayaNotes.Dashboards;
                this.releaseNotes.AvayaNotes.Wallboards =
                    this.releaseNotesLocal.German.AvayaNotes.Wallboards;
                //UJet
                this.releaseNotes.UJetNotes.General =
                    this.releaseNotesLocal.German.UJetNotes.General;
                this.releaseNotes.UJetNotes.Messaging =
                    this.releaseNotesLocal.German.UJetNotes.Messaging;
                this.releaseNotes.UJetNotes.Gamification =
                    this.releaseNotesLocal.German.UJetNotes.Gamification;
                this.releaseNotes.UJetNotes.Coaching =
                    this.releaseNotesLocal.German.UJetNotes.Coaching;
                this.releaseNotes.UJetNotes.QA =
                    this.releaseNotesLocal.German.UJetNotes.QA;
                this.releaseNotes.UJetNotes.Dashboards =
                    this.releaseNotesLocal.German.UJetNotes.Dashboards;
                this.releaseNotes.UJetNotes.Wallboards =
                    this.releaseNotesLocal.German.UJetNotes.Wallboards;
                break;

            case "Français Canadien":
                this.greetings =
                    this.releaseNotesLocal.CanadianFrench.Greetings;
                this.acknowledge =
                    this.releaseNotesLocal.CanadianFrench.acknowledge;
                this.releaseNotes.releaseVersion =
                    this.releaseNotesLocal.CanadianFrench.releaseVersion;

                //RegularNotes
                this.releaseNotes.Notes.General =
                    this.releaseNotesLocal.CanadianFrench.Notes.General;
                this.releaseNotes.Notes.Messaging =
                    this.releaseNotesLocal.CanadianFrench.Notes.Messaging;
                this.releaseNotes.Notes.Gamification =
                    this.releaseNotesLocal.CanadianFrench.Notes.Gamification;
                this.releaseNotes.Notes.Coaching =
                    this.releaseNotesLocal.CanadianFrench.Notes.Coaching;
                this.releaseNotes.Notes.QA =
                    this.releaseNotesLocal.CanadianFrench.Notes.QA;
                this.releaseNotes.Notes.Dashboards =
                    this.releaseNotesLocal.CanadianFrench.Notes.Dashboards;
                this.releaseNotes.Notes.Wallboards =
                    this.releaseNotesLocal.CanadianFrench.Notes.Wallboards;
                //PartnerNotes
                //Direct
                this.releaseNotes.DirectNotes.General =
                    this.releaseNotesLocal.CanadianFrench.DirectNotes.General;
                this.releaseNotes.DirectNotes.Messaging =
                    this.releaseNotesLocal.CanadianFrench.DirectNotes.Messaging;
                this.releaseNotes.DirectNotes.Gamification =
                    this.releaseNotesLocal.CanadianFrench.DirectNotes.Gamification;
                this.releaseNotes.DirectNotes.Coaching =
                    this.releaseNotesLocal.CanadianFrench.DirectNotes.Coaching;
                this.releaseNotes.DirectNotes.QA =
                    this.releaseNotesLocal.CanadianFrench.DirectNotes.QA;
                this.releaseNotes.DirectNotes.Dashboards =
                    this.releaseNotesLocal.CanadianFrench.DirectNotes.Dashboards;
                this.releaseNotes.DirectNotes.Wallboards =
                    this.releaseNotesLocal.CanadianFrench.DirectNotes.Wallboards;
                //NiceInContact
                this.releaseNotes.NiceInContactNotes.General =
                    this.releaseNotesLocal.CanadianFrench.NiceInContactNotes.General;
                this.releaseNotes.NiceInContactNotes.Messaging =
                    this.releaseNotesLocal.CanadianFrench.NiceInContactNotes.Messaging;
                this.releaseNotes.NiceInContactNotes.Gamification =
                    this.releaseNotesLocal.CanadianFrench.NiceInContactNotes.Gamification;
                this.releaseNotes.NiceInContactNotes.Coaching =
                    this.releaseNotesLocal.CanadianFrench.NiceInContactNotes.Coaching;
                this.releaseNotes.NiceInContactNotes.QA =
                    this.releaseNotesLocal.CanadianFrench.NiceInContactNotes.QA;
                this.releaseNotes.NiceInContactNotes.Dashboards =
                    this.releaseNotesLocal.CanadianFrench.NiceInContactNotes.Dashboards;
                this.releaseNotes.NiceInContactNotes.Wallboards =
                    this.releaseNotesLocal.CanadianFrench.NiceInContactNotes.Wallboards;
                //Five9
                this.releaseNotes.Five9Notes.General =
                    this.releaseNotesLocal.CanadianFrench.Five9Notes.General;
                this.releaseNotes.Five9Notes.Messaging =
                    this.releaseNotesLocal.CanadianFrench.Five9Notes.Messaging;
                this.releaseNotes.Five9Notes.Gamification =
                    this.releaseNotesLocal.CanadianFrench.Five9Notes.Gamification;
                this.releaseNotes.Five9Notes.Coaching =
                    this.releaseNotesLocal.CanadianFrench.Five9Notes.Coaching;
                this.releaseNotes.Five9Notes.QA =
                    this.releaseNotesLocal.CanadianFrench.Five9Notes.QA;
                this.releaseNotes.Five9Notes.Dashboards =
                    this.releaseNotesLocal.CanadianFrench.Five9Notes.Dashboards;
                this.releaseNotes.Five9Notes.Wallboards =
                    this.releaseNotesLocal.CanadianFrench.Five9Notes.Wallboards;
                //Serenova
                this.releaseNotes.SerenovaNotes.General =
                    this.releaseNotesLocal.CanadianFrench.SerenovaNotes.General;
                this.releaseNotes.SerenovaNotes.Messaging =
                    this.releaseNotesLocal.CanadianFrench.SerenovaNotes.Messaging;
                this.releaseNotes.SerenovaNotes.Gamification =
                    this.releaseNotesLocal.CanadianFrench.SerenovaNotes.Gamification;
                this.releaseNotes.SerenovaNotes.Coaching =
                    this.releaseNotesLocal.CanadianFrench.SerenovaNotes.Coaching;
                this.releaseNotes.SerenovaNotes.QA =
                    this.releaseNotesLocal.CanadianFrench.SerenovaNotes.QA;
                this.releaseNotes.SerenovaNotes.Dashboards =
                    this.releaseNotesLocal.CanadianFrench.SerenovaNotes.Dashboards;
                this.releaseNotes.SerenovaNotes.Wallboards =
                    this.releaseNotesLocal.CanadianFrench.SerenovaNotes.Wallboards;
                //Genesys
                this.releaseNotes.GenesysNotes.General =
                    this.releaseNotesLocal.CanadianFrench.GenesysNotes.General;
                this.releaseNotes.GenesysNotes.Messaging =
                    this.releaseNotesLocal.CanadianFrench.GenesysNotes.Messaging;
                this.releaseNotes.GenesysNotes.Gamification =
                    this.releaseNotesLocal.CanadianFrench.GenesysNotes.Gamification;
                this.releaseNotes.GenesysNotes.Coaching =
                    this.releaseNotesLocal.CanadianFrench.GenesysNotes.Coaching;
                this.releaseNotes.GenesysNotes.QA =
                    this.releaseNotesLocal.CanadianFrench.GenesysNotes.QA;
                this.releaseNotes.GenesysNotes.Dashboards =
                    this.releaseNotesLocal.CanadianFrench.GenesysNotes.Dashboards;
                this.releaseNotes.GenesysNotes.Wallboards =
                    this.releaseNotesLocal.CanadianFrench.GenesysNotes.Wallboards;
                //Cisco
                this.releaseNotes.CiscoNotes.General =
                    this.releaseNotesLocal.CanadianFrench.CiscoNotes.General;
                this.releaseNotes.CiscoNotes.Messaging =
                    this.releaseNotesLocal.CanadianFrench.CiscoNotes.Messaging;
                this.releaseNotes.CiscoNotes.Gamification =
                    this.releaseNotesLocal.CanadianFrench.CiscoNotes.Gamification;
                this.releaseNotes.CiscoNotes.Coaching =
                    this.releaseNotesLocal.CanadianFrench.CiscoNotes.Coaching;
                this.releaseNotes.CiscoNotes.QA =
                    this.releaseNotesLocal.CanadianFrench.CiscoNotes.QA;
                this.releaseNotes.CiscoNotes.Dashboards =
                    this.releaseNotesLocal.CanadianFrench.CiscoNotes.Dashboards;
                this.releaseNotes.CiscoNotes.Wallboards =
                    this.releaseNotesLocal.CanadianFrench.CiscoNotes.Wallboards;
                //Amazon
                this.releaseNotes.AmazonNotes.General =
                    this.releaseNotesLocal.CanadianFrench.AmazonNotes.General;
                this.releaseNotes.AmazonNotes.Messaging =
                    this.releaseNotesLocal.CanadianFrench.AmazonNotes.Messaging;
                this.releaseNotes.AmazonNotes.Gamification =
                    this.releaseNotesLocal.CanadianFrench.AmazonNotes.Gamification;
                this.releaseNotes.AmazonNotes.Coaching =
                    this.releaseNotesLocal.CanadianFrench.AmazonNotes.Coaching;
                this.releaseNotes.AmazonNotes.QA =
                    this.releaseNotesLocal.CanadianFrench.AmazonNotes.QA;
                this.releaseNotes.AmazonNotes.Dashboards =
                    this.releaseNotesLocal.CanadianFrench.AmazonNotes.Dashboards;
                this.releaseNotes.AmazonNotes.Wallboards =
                    this.releaseNotesLocal.CanadianFrench.AmazonNotes.Wallboards;
                //Avaya
                this.releaseNotes.AvayaNotes.General =
                    this.releaseNotesLocal.CanadianFrench.AvayaNotes.General;
                this.releaseNotes.AvayaNotes.Messaging =
                    this.releaseNotesLocal.CanadianFrench.AvayaNotes.Messaging;
                this.releaseNotes.AvayaNotes.Gamification =
                    this.releaseNotesLocal.CanadianFrench.AvayaNotes.Gamification;
                this.releaseNotes.AvayaNotes.Coaching =
                    this.releaseNotesLocal.CanadianFrench.AvayaNotes.Coaching;
                this.releaseNotes.AvayaNotes.QA =
                    this.releaseNotesLocal.CanadianFrench.AvayaNotes.QA;
                this.releaseNotes.AvayaNotes.Dashboards =
                    this.releaseNotesLocal.CanadianFrench.AvayaNotes.Dashboards;
                this.releaseNotes.AvayaNotes.Wallboards =
                    this.releaseNotesLocal.CanadianFrench.AvayaNotes.Wallboards;
                //UJet
                this.releaseNotes.UJetNotes.General =
                    this.releaseNotesLocal.CanadianFrench.UJetNotes.General;
                this.releaseNotes.UJetNotes.Messaging =
                    this.releaseNotesLocal.CanadianFrench.UJetNotes.Messaging;
                this.releaseNotes.UJetNotes.Gamification =
                    this.releaseNotesLocal.CanadianFrench.UJetNotes.Gamification;
                this.releaseNotes.UJetNotes.Coaching =
                    this.releaseNotesLocal.CanadianFrench.UJetNotes.Coaching;
                this.releaseNotes.UJetNotes.QA =
                    this.releaseNotesLocal.CanadianFrench.UJetNotes.QA;
                this.releaseNotes.UJetNotes.Dashboards =
                    this.releaseNotesLocal.CanadianFrench.UJetNotes.Dashboards;
                this.releaseNotes.UJetNotes.Wallboards =
                    this.releaseNotesLocal.CanadianFrench.UJetNotes.Wallboards;
                break;
            case "Portugues do Brasil":
                this.greetings =
                    this.releaseNotesLocal.BrazilianPortuguese.Greetings;
                this.acknowledge =
                    this.releaseNotesLocal.BrazilianPortuguese.acknowledge;
                this.releaseNotes.releaseVersion =
                    this.releaseNotesLocal.BrazilianPortuguese.releaseVersion;

                //RegularNotes
                this.releaseNotes.Notes.General =
                    this.releaseNotesLocal.BrazilianPortuguese.Notes.General;
                this.releaseNotes.Notes.Messaging =
                    this.releaseNotesLocal.BrazilianPortuguese.Notes.Messaging;
                this.releaseNotes.Notes.Gamification =
                    this.releaseNotesLocal.BrazilianPortuguese.Notes.Gamification;
                this.releaseNotes.Notes.Coaching =
                    this.releaseNotesLocal.BrazilianPortuguese.Notes.Coaching;
                this.releaseNotes.Notes.QA =
                    this.releaseNotesLocal.BrazilianPortuguese.Notes.QA;
                this.releaseNotes.Notes.Dashboards =
                    this.releaseNotesLocal.BrazilianPortuguese.Notes.Dashboards;
                this.releaseNotes.Notes.Wallboards =
                    this.releaseNotesLocal.BrazilianPortuguese.Notes.Wallboards;
                //PartnerNotes
                //Direct
                this.releaseNotes.DirectNotes.General =
                    this.releaseNotesLocal.BrazilianPortuguese.DirectNotes.General;
                this.releaseNotes.DirectNotes.Messaging =
                    this.releaseNotesLocal.BrazilianPortuguese.DirectNotes.Messaging;
                this.releaseNotes.DirectNotes.Gamification =
                    this.releaseNotesLocal.BrazilianPortuguese.DirectNotes.Gamification;
                this.releaseNotes.DirectNotes.Coaching =
                    this.releaseNotesLocal.BrazilianPortuguese.DirectNotes.Coaching;
                this.releaseNotes.DirectNotes.QA =
                    this.releaseNotesLocal.BrazilianPortuguese.DirectNotes.QA;
                this.releaseNotes.DirectNotes.Dashboards =
                    this.releaseNotesLocal.BrazilianPortuguese.DirectNotes.Dashboards;
                this.releaseNotes.DirectNotes.Wallboards =
                    this.releaseNotesLocal.BrazilianPortuguese.DirectNotes.Wallboards;
                //NiceInContact
                this.releaseNotes.NiceInContactNotes.General =
                    this.releaseNotesLocal.BrazilianPortuguese.NiceInContactNotes.General;
                this.releaseNotes.NiceInContactNotes.Messaging =
                    this.releaseNotesLocal.BrazilianPortuguese.NiceInContactNotes.Messaging;
                this.releaseNotes.NiceInContactNotes.Gamification =
                    this.releaseNotesLocal.BrazilianPortuguese.NiceInContactNotes.Gamification;
                this.releaseNotes.NiceInContactNotes.Coaching =
                    this.releaseNotesLocal.BrazilianPortuguese.NiceInContactNotes.Coaching;
                this.releaseNotes.NiceInContactNotes.QA =
                    this.releaseNotesLocal.BrazilianPortuguese.NiceInContactNotes.QA;
                this.releaseNotes.NiceInContactNotes.Dashboards =
                    this.releaseNotesLocal.BrazilianPortuguese.NiceInContactNotes.Dashboards;
                this.releaseNotes.NiceInContactNotes.Wallboards =
                    this.releaseNotesLocal.BrazilianPortuguese.NiceInContactNotes.Wallboards;
                //Five9
                this.releaseNotes.Five9Notes.General =
                    this.releaseNotesLocal.BrazilianPortuguese.Five9Notes.General;
                this.releaseNotes.Five9Notes.Messaging =
                    this.releaseNotesLocal.BrazilianPortuguese.Five9Notes.Messaging;
                this.releaseNotes.Five9Notes.Gamification =
                    this.releaseNotesLocal.BrazilianPortuguese.Five9Notes.Gamification;
                this.releaseNotes.Five9Notes.Coaching =
                    this.releaseNotesLocal.BrazilianPortuguese.Five9Notes.Coaching;
                this.releaseNotes.Five9Notes.QA =
                    this.releaseNotesLocal.BrazilianPortuguese.Five9Notes.QA;
                this.releaseNotes.Five9Notes.Dashboards =
                    this.releaseNotesLocal.BrazilianPortuguese.Five9Notes.Dashboards;
                this.releaseNotes.Five9Notes.Wallboards =
                    this.releaseNotesLocal.BrazilianPortuguese.Five9Notes.Wallboards;
                //Serenova
                this.releaseNotes.SerenovaNotes.General =
                    this.releaseNotesLocal.BrazilianPortuguese.SerenovaNotes.General;
                this.releaseNotes.SerenovaNotes.Messaging =
                    this.releaseNotesLocal.BrazilianPortuguese.SerenovaNotes.Messaging;
                this.releaseNotes.SerenovaNotes.Gamification =
                    this.releaseNotesLocal.BrazilianPortuguese.SerenovaNotes.Gamification;
                this.releaseNotes.SerenovaNotes.Coaching =
                    this.releaseNotesLocal.BrazilianPortuguese.SerenovaNotes.Coaching;
                this.releaseNotes.SerenovaNotes.QA =
                    this.releaseNotesLocal.BrazilianPortuguese.SerenovaNotes.QA;
                this.releaseNotes.SerenovaNotes.Dashboards =
                    this.releaseNotesLocal.BrazilianPortuguese.SerenovaNotes.Dashboards;
                this.releaseNotes.SerenovaNotes.Wallboards =
                    this.releaseNotesLocal.BrazilianPortuguese.SerenovaNotes.Wallboards;
                //Genesys
                this.releaseNotes.GenesysNotes.General =
                    this.releaseNotesLocal.BrazilianPortuguese.GenesysNotes.General;
                this.releaseNotes.GenesysNotes.Messaging =
                    this.releaseNotesLocal.BrazilianPortuguese.GenesysNotes.Messaging;
                this.releaseNotes.GenesysNotes.Gamification =
                    this.releaseNotesLocal.BrazilianPortuguese.GenesysNotes.Gamification;
                this.releaseNotes.GenesysNotes.Coaching =
                    this.releaseNotesLocal.BrazilianPortuguese.GenesysNotes.Coaching;
                this.releaseNotes.GenesysNotes.QA =
                    this.releaseNotesLocal.BrazilianPortuguese.GenesysNotes.QA;
                this.releaseNotes.GenesysNotes.Dashboards =
                    this.releaseNotesLocal.BrazilianPortuguese.GenesysNotes.Dashboards;
                this.releaseNotes.GenesysNotes.Wallboards =
                    this.releaseNotesLocal.BrazilianPortuguese.GenesysNotes.Wallboards;
                //Cisco
                this.releaseNotes.CiscoNotes.General =
                    this.releaseNotesLocal.BrazilianPortuguese.CiscoNotes.General;
                this.releaseNotes.CiscoNotes.Messaging =
                    this.releaseNotesLocal.BrazilianPortuguese.CiscoNotes.Messaging;
                this.releaseNotes.CiscoNotes.Gamification =
                    this.releaseNotesLocal.BrazilianPortuguese.CiscoNotes.Gamification;
                this.releaseNotes.CiscoNotes.Coaching =
                    this.releaseNotesLocal.BrazilianPortuguese.CiscoNotes.Coaching;
                this.releaseNotes.CiscoNotes.QA =
                    this.releaseNotesLocal.BrazilianPortuguese.CiscoNotes.QA;
                this.releaseNotes.CiscoNotes.Dashboards =
                    this.releaseNotesLocal.BrazilianPortuguese.CiscoNotes.Dashboards;
                this.releaseNotes.CiscoNotes.Wallboards =
                    this.releaseNotesLocal.BrazilianPortuguese.CiscoNotes.Wallboards;
                //Amazon
                this.releaseNotes.AmazonNotes.General =
                    this.releaseNotesLocal.BrazilianPortuguese.AmazonNotes.General;
                this.releaseNotes.AmazonNotes.Messaging =
                    this.releaseNotesLocal.BrazilianPortuguese.AmazonNotes.Messaging;
                this.releaseNotes.AmazonNotes.Gamification =
                    this.releaseNotesLocal.BrazilianPortuguese.AmazonNotes.Gamification;
                this.releaseNotes.AmazonNotes.Coaching =
                    this.releaseNotesLocal.BrazilianPortuguese.AmazonNotes.Coaching;
                this.releaseNotes.AmazonNotes.QA =
                    this.releaseNotesLocal.BrazilianPortuguese.AmazonNotes.QA;
                this.releaseNotes.AmazonNotes.Dashboards =
                    this.releaseNotesLocal.BrazilianPortuguese.AmazonNotes.Dashboards;
                this.releaseNotes.AmazonNotes.Wallboards =
                    this.releaseNotesLocal.BrazilianPortuguese.AmazonNotes.Wallboards;
                //Avaya
                this.releaseNotes.AvayaNotes.General =
                    this.releaseNotesLocal.BrazilianPortuguese.AvayaNotes.General;
                this.releaseNotes.AvayaNotes.Messaging =
                    this.releaseNotesLocal.BrazilianPortuguese.AvayaNotes.Messaging;
                this.releaseNotes.AvayaNotes.Gamification =
                    this.releaseNotesLocal.BrazilianPortuguese.AvayaNotes.Gamification;
                this.releaseNotes.AvayaNotes.Coaching =
                    this.releaseNotesLocal.BrazilianPortuguese.AvayaNotes.Coaching;
                this.releaseNotes.AvayaNotes.QA =
                    this.releaseNotesLocal.BrazilianPortuguese.AvayaNotes.QA;
                this.releaseNotes.AvayaNotes.Dashboards =
                    this.releaseNotesLocal.BrazilianPortuguese.AvayaNotes.Dashboards;
                this.releaseNotes.AvayaNotes.Wallboards =
                    this.releaseNotesLocal.BrazilianPortuguese.AvayaNotes.Wallboards;
                //UJet
                this.releaseNotes.UJetNotes.General =
                    this.releaseNotesLocal.BrazilianPortuguese.UJetNotes.General;
                this.releaseNotes.UJetNotes.Messaging =
                    this.releaseNotesLocal.BrazilianPortuguese.UJetNotes.Messaging;
                this.releaseNotes.UJetNotes.Gamification =
                    this.releaseNotesLocal.BrazilianPortuguese.UJetNotes.Gamification;
                this.releaseNotes.UJetNotes.Coaching =
                    this.releaseNotesLocal.BrazilianPortuguese.UJetNotes.Coaching;
                this.releaseNotes.UJetNotes.QA =
                    this.releaseNotesLocal.BrazilianPortuguese.UJetNotes.QA;
                this.releaseNotes.UJetNotes.Dashboards =
                    this.releaseNotesLocal.BrazilianPortuguese.UJetNotes.Dashboards;
                this.releaseNotes.UJetNotes.Wallboards =
                    this.releaseNotesLocal.BrazilianPortuguese.UJetNotes.Wallboards;
                break;
            case "Nederlands":
                this.greetings = this.releaseNotesLocal.Dutch.Greetings;
                this.acknowledge = this.releaseNotesLocal.Dutch.acknowledge;
                this.releaseNotes.releaseVersion =
                    this.releaseNotesLocal.Dutch.releaseVersion;

                //RegularNotes
                this.releaseNotes.Notes.General =
                    this.releaseNotesLocal.Dutch.Notes.General;
                this.releaseNotes.Notes.Messaging =
                    this.releaseNotesLocal.Dutch.Notes.Messaging;
                this.releaseNotes.Notes.Gamification =
                    this.releaseNotesLocal.Dutch.Notes.Gamification;
                this.releaseNotes.Notes.Coaching =
                    this.releaseNotesLocal.Dutch.Notes.Coaching;
                this.releaseNotes.Notes.QA =
                    this.releaseNotesLocal.Dutch.Notes.QA;
                this.releaseNotes.Notes.Dashboards =
                    this.releaseNotesLocal.Dutch.Notes.Dashboards;
                this.releaseNotes.Notes.Wallboards =
                    this.releaseNotesLocal.Dutch.Notes.Wallboards;
                //PartnerNotes
                //Direct
                this.releaseNotes.DirectNotes.General =
                    this.releaseNotesLocal.Dutch.DirectNotes.General;
                this.releaseNotes.DirectNotes.Messaging =
                    this.releaseNotesLocal.Dutch.DirectNotes.Messaging;
                this.releaseNotes.DirectNotes.Gamification =
                    this.releaseNotesLocal.Dutch.DirectNotes.Gamification;
                this.releaseNotes.DirectNotes.Coaching =
                    this.releaseNotesLocal.Dutch.DirectNotes.Coaching;
                this.releaseNotes.DirectNotes.QA =
                    this.releaseNotesLocal.Dutch.DirectNotes.QA;
                this.releaseNotes.DirectNotes.Dashboards =
                    this.releaseNotesLocal.Dutch.DirectNotes.Dashboards;
                this.releaseNotes.DirectNotes.Wallboards =
                    this.releaseNotesLocal.Dutch.DirectNotes.Wallboards;
                //NiceInContact
                this.releaseNotes.NiceInContactNotes.General =
                    this.releaseNotesLocal.Dutch.NiceInContactNotes.General;
                this.releaseNotes.NiceInContactNotes.Messaging =
                    this.releaseNotesLocal.Dutch.NiceInContactNotes.Messaging;
                this.releaseNotes.NiceInContactNotes.Gamification =
                    this.releaseNotesLocal.Dutch.NiceInContactNotes.Gamification;
                this.releaseNotes.NiceInContactNotes.Coaching =
                    this.releaseNotesLocal.Dutch.NiceInContactNotes.Coaching;
                this.releaseNotes.NiceInContactNotes.QA =
                    this.releaseNotesLocal.Dutch.NiceInContactNotes.QA;
                this.releaseNotes.NiceInContactNotes.Dashboards =
                    this.releaseNotesLocal.Dutch.NiceInContactNotes.Dashboards;
                this.releaseNotes.NiceInContactNotes.Wallboards =
                    this.releaseNotesLocal.Dutch.NiceInContactNotes.Wallboards;
                //Five9
                this.releaseNotes.Five9Notes.General =
                    this.releaseNotesLocal.Dutch.Five9Notes.General;
                this.releaseNotes.Five9Notes.Messaging =
                    this.releaseNotesLocal.Dutch.Five9Notes.Messaging;
                this.releaseNotes.Five9Notes.Gamification =
                    this.releaseNotesLocal.Dutch.Five9Notes.Gamification;
                this.releaseNotes.Five9Notes.Coaching =
                    this.releaseNotesLocal.Dutch.Five9Notes.Coaching;
                this.releaseNotes.Five9Notes.QA =
                    this.releaseNotesLocal.Dutch.Five9Notes.QA;
                this.releaseNotes.Five9Notes.Dashboards =
                    this.releaseNotesLocal.Dutch.Five9Notes.Dashboards;
                this.releaseNotes.Five9Notes.Wallboards =
                    this.releaseNotesLocal.Dutch.Five9Notes.Wallboards;
                //Serenova
                this.releaseNotes.SerenovaNotes.General =
                    this.releaseNotesLocal.Dutch.SerenovaNotes.General;
                this.releaseNotes.SerenovaNotes.Messaging =
                    this.releaseNotesLocal.Dutch.SerenovaNotes.Messaging;
                this.releaseNotes.SerenovaNotes.Gamification =
                    this.releaseNotesLocal.Dutch.SerenovaNotes.Gamification;
                this.releaseNotes.SerenovaNotes.Coaching =
                    this.releaseNotesLocal.Dutch.SerenovaNotes.Coaching;
                this.releaseNotes.SerenovaNotes.QA =
                    this.releaseNotesLocal.Dutch.SerenovaNotes.QA;
                this.releaseNotes.SerenovaNotes.Dashboards =
                    this.releaseNotesLocal.Dutch.SerenovaNotes.Dashboards;
                this.releaseNotes.SerenovaNotes.Wallboards =
                    this.releaseNotesLocal.Dutch.SerenovaNotes.Wallboards;
                //Genesys
                this.releaseNotes.GenesysNotes.General =
                    this.releaseNotesLocal.Dutch.GenesysNotes.General;
                this.releaseNotes.GenesysNotes.Messaging =
                    this.releaseNotesLocal.Dutch.GenesysNotes.Messaging;
                this.releaseNotes.GenesysNotes.Gamification =
                    this.releaseNotesLocal.Dutch.GenesysNotes.Gamification;
                this.releaseNotes.GenesysNotes.Coaching =
                    this.releaseNotesLocal.Dutch.GenesysNotes.Coaching;
                this.releaseNotes.GenesysNotes.QA =
                    this.releaseNotesLocal.Dutch.GenesysNotes.QA;
                this.releaseNotes.GenesysNotes.Dashboards =
                    this.releaseNotesLocal.Dutch.GenesysNotes.Dashboards;
                this.releaseNotes.GenesysNotes.Wallboards =
                    this.releaseNotesLocal.Dutch.GenesysNotes.Wallboards;
                //Cisco
                this.releaseNotes.CiscoNotes.General =
                    this.releaseNotesLocal.Dutch.CiscoNotes.General;
                this.releaseNotes.CiscoNotes.Messaging =
                    this.releaseNotesLocal.Dutch.CiscoNotes.Messaging;
                this.releaseNotes.CiscoNotes.Gamification =
                    this.releaseNotesLocal.Dutch.CiscoNotes.Gamification;
                this.releaseNotes.CiscoNotes.Coaching =
                    this.releaseNotesLocal.Dutch.CiscoNotes.Coaching;
                this.releaseNotes.CiscoNotes.QA =
                    this.releaseNotesLocal.Dutch.CiscoNotes.QA;
                this.releaseNotes.CiscoNotes.Dashboards =
                    this.releaseNotesLocal.Dutch.CiscoNotes.Dashboards;
                this.releaseNotes.CiscoNotes.Wallboards =
                    this.releaseNotesLocal.Dutch.CiscoNotes.Wallboards;
                //Amazon
                this.releaseNotes.AmazonNotes.General =
                    this.releaseNotesLocal.Dutch.AmazonNotes.General;
                this.releaseNotes.AmazonNotes.Messaging =
                    this.releaseNotesLocal.Dutch.AmazonNotes.Messaging;
                this.releaseNotes.AmazonNotes.Gamification =
                    this.releaseNotesLocal.Dutch.AmazonNotes.Gamification;
                this.releaseNotes.AmazonNotes.Coaching =
                    this.releaseNotesLocal.Dutch.AmazonNotes.Coaching;
                this.releaseNotes.AmazonNotes.QA =
                    this.releaseNotesLocal.Dutch.AmazonNotes.QA;
                this.releaseNotes.AmazonNotes.Dashboards =
                    this.releaseNotesLocal.Dutch.AmazonNotes.Dashboards;
                this.releaseNotes.AmazonNotes.Wallboards =
                    this.releaseNotesLocal.Dutch.AmazonNotes.Wallboards;
                //Avaya
                this.releaseNotes.AvayaNotes.General =
                    this.releaseNotesLocal.Dutch.AvayaNotes.General;
                this.releaseNotes.AvayaNotes.Messaging =
                    this.releaseNotesLocal.Dutch.AvayaNotes.Messaging;
                this.releaseNotes.AvayaNotes.Gamification =
                    this.releaseNotesLocal.Dutch.AvayaNotes.Gamification;
                this.releaseNotes.AvayaNotes.Coaching =
                    this.releaseNotesLocal.Dutch.AvayaNotes.Coaching;
                this.releaseNotes.AvayaNotes.QA =
                    this.releaseNotesLocal.Dutch.AvayaNotes.QA;
                this.releaseNotes.AvayaNotes.Dashboards =
                    this.releaseNotesLocal.Dutch.AvayaNotes.Dashboards;
                this.releaseNotes.AvayaNotes.Wallboards =
                    this.releaseNotesLocal.Dutch.AvayaNotes.Wallboards;
                //UJet
                this.releaseNotes.UJetNotes.General =
                    this.releaseNotesLocal.Dutch.UJetNotes.General;
                this.releaseNotes.UJetNotes.Messaging =
                    this.releaseNotesLocal.Dutch.UJetNotes.Messaging;
                this.releaseNotes.UJetNotes.Gamification =
                    this.releaseNotesLocal.Dutch.UJetNotes.Gamification;
                this.releaseNotes.UJetNotes.Coaching =
                    this.releaseNotesLocal.Dutch.UJetNotes.Coaching;
                this.releaseNotes.UJetNotes.QA =
                    this.releaseNotesLocal.Dutch.UJetNotes.QA;
                this.releaseNotes.UJetNotes.Dashboards =
                    this.releaseNotesLocal.Dutch.UJetNotes.Dashboards;
                this.releaseNotes.UJetNotes.Wallboards =
                    this.releaseNotesLocal.Dutch.UJetNotes.Wallboards;
                break;
            case "Japanese":
                this.greetings = this.releaseNotesLocal.Japanese.Greetings;
                this.acknowledge = this.releaseNotesLocal.Japanese.acknowledge;
                this.releaseNotes.releaseVersion =
                    this.releaseNotesLocal.Japanese.releaseVersion;

                //RegularNotes
                this.releaseNotes.Notes.General =
                    this.releaseNotesLocal.Japanese.Notes.General;
                this.releaseNotes.Notes.Messaging =
                    this.releaseNotesLocal.Japanese.Notes.Messaging;
                this.releaseNotes.Notes.Gamification =
                    this.releaseNotesLocal.Japanese.Notes.Gamification;
                this.releaseNotes.Notes.Coaching =
                    this.releaseNotesLocal.Japanese.Notes.Coaching;
                this.releaseNotes.Notes.QA =
                    this.releaseNotesLocal.Japanese.Notes.QA;
                this.releaseNotes.Notes.Dashboards =
                    this.releaseNotesLocal.Japanese.Notes.Dashboards;
                this.releaseNotes.Notes.Wallboards =
                    this.releaseNotesLocal.Japanese.Notes.Wallboards;
                //PartnerNotes
                //Direct
                this.releaseNotes.DirectNotes.General =
                    this.releaseNotesLocal.Japanese.DirectNotes.General;
                this.releaseNotes.DirectNotes.Messaging =
                    this.releaseNotesLocal.Japanese.DirectNotes.Messaging;
                this.releaseNotes.DirectNotes.Gamification =
                    this.releaseNotesLocal.Japanese.DirectNotes.Gamification;
                this.releaseNotes.DirectNotes.Coaching =
                    this.releaseNotesLocal.Japanese.DirectNotes.Coaching;
                this.releaseNotes.DirectNotes.QA =
                    this.releaseNotesLocal.Japanese.DirectNotes.QA;
                this.releaseNotes.DirectNotes.Dashboards =
                    this.releaseNotesLocal.Japanese.DirectNotes.Dashboards;
                this.releaseNotes.DirectNotes.Wallboards =
                    this.releaseNotesLocal.Japanese.DirectNotes.Wallboards;
                //NiceInContact
                this.releaseNotes.NiceInContactNotes.General =
                    this.releaseNotesLocal.Japanese.NiceInContactNotes.General;
                this.releaseNotes.NiceInContactNotes.Messaging =
                    this.releaseNotesLocal.Japanese.NiceInContactNotes.Messaging;
                this.releaseNotes.NiceInContactNotes.Gamification =
                    this.releaseNotesLocal.Japanese.NiceInContactNotes.Gamification;
                this.releaseNotes.NiceInContactNotes.Coaching =
                    this.releaseNotesLocal.Japanese.NiceInContactNotes.Coaching;
                this.releaseNotes.NiceInContactNotes.QA =
                    this.releaseNotesLocal.Japanese.NiceInContactNotes.QA;
                this.releaseNotes.NiceInContactNotes.Dashboards =
                    this.releaseNotesLocal.Japanese.NiceInContactNotes.Dashboards;
                this.releaseNotes.NiceInContactNotes.Wallboards =
                    this.releaseNotesLocal.Japanese.NiceInContactNotes.Wallboards;
                //Five9
                this.releaseNotes.Five9Notes.General =
                    this.releaseNotesLocal.Japanese.Five9Notes.General;
                this.releaseNotes.Five9Notes.Messaging =
                    this.releaseNotesLocal.Japanese.Five9Notes.Messaging;
                this.releaseNotes.Five9Notes.Gamification =
                    this.releaseNotesLocal.Japanese.Five9Notes.Gamification;
                this.releaseNotes.Five9Notes.Coaching =
                    this.releaseNotesLocal.Japanese.Five9Notes.Coaching;
                this.releaseNotes.Five9Notes.QA =
                    this.releaseNotesLocal.Japanese.Five9Notes.QA;
                this.releaseNotes.Five9Notes.Dashboards =
                    this.releaseNotesLocal.Japanese.Five9Notes.Dashboards;
                this.releaseNotes.Five9Notes.Wallboards =
                    this.releaseNotesLocal.Japanese.Five9Notes.Wallboards;
                //Serenova
                this.releaseNotes.SerenovaNotes.General =
                    this.releaseNotesLocal.Japanese.SerenovaNotes.General;
                this.releaseNotes.SerenovaNotes.Messaging =
                    this.releaseNotesLocal.Japanese.SerenovaNotes.Messaging;
                this.releaseNotes.SerenovaNotes.Gamification =
                    this.releaseNotesLocal.Japanese.SerenovaNotes.Gamification;
                this.releaseNotes.SerenovaNotes.Coaching =
                    this.releaseNotesLocal.Japanese.SerenovaNotes.Coaching;
                this.releaseNotes.SerenovaNotes.QA =
                    this.releaseNotesLocal.Japanese.SerenovaNotes.QA;
                this.releaseNotes.SerenovaNotes.Dashboards =
                    this.releaseNotesLocal.Japanese.SerenovaNotes.Dashboards;
                this.releaseNotes.SerenovaNotes.Wallboards =
                    this.releaseNotesLocal.Japanese.SerenovaNotes.Wallboards;
                //Genesys
                this.releaseNotes.GenesysNotes.General =
                    this.releaseNotesLocal.Japanese.GenesysNotes.General;
                this.releaseNotes.GenesysNotes.Messaging =
                    this.releaseNotesLocal.Japanese.GenesysNotes.Messaging;
                this.releaseNotes.GenesysNotes.Gamification =
                    this.releaseNotesLocal.Japanese.GenesysNotes.Gamification;
                this.releaseNotes.GenesysNotes.Coaching =
                    this.releaseNotesLocal.Japanese.GenesysNotes.Coaching;
                this.releaseNotes.GenesysNotes.QA =
                    this.releaseNotesLocal.Japanese.GenesysNotes.QA;
                this.releaseNotes.GenesysNotes.Dashboards =
                    this.releaseNotesLocal.Japanese.GenesysNotes.Dashboards;
                this.releaseNotes.GenesysNotes.Wallboards =
                    this.releaseNotesLocal.Japanese.GenesysNotes.Wallboards;
                //Cisco
                this.releaseNotes.CiscoNotes.General =
                    this.releaseNotesLocal.Japanese.CiscoNotes.General;
                this.releaseNotes.CiscoNotes.Messaging =
                    this.releaseNotesLocal.Japanese.CiscoNotes.Messaging;
                this.releaseNotes.CiscoNotes.Gamification =
                    this.releaseNotesLocal.Japanese.CiscoNotes.Gamification;
                this.releaseNotes.CiscoNotes.Coaching =
                    this.releaseNotesLocal.Japanese.CiscoNotes.Coaching;
                this.releaseNotes.CiscoNotes.QA =
                    this.releaseNotesLocal.Japanese.CiscoNotes.QA;
                this.releaseNotes.CiscoNotes.Dashboards =
                    this.releaseNotesLocal.Japanese.CiscoNotes.Dashboards;
                this.releaseNotes.CiscoNotes.Wallboards =
                    this.releaseNotesLocal.Japanese.CiscoNotes.Wallboards;
                //Amazon
                this.releaseNotes.AmazonNotes.General =
                    this.releaseNotesLocal.Japanese.AmazonNotes.General;
                this.releaseNotes.AmazonNotes.Messaging =
                    this.releaseNotesLocal.Japanese.AmazonNotes.Messaging;
                this.releaseNotes.AmazonNotes.Gamification =
                    this.releaseNotesLocal.Japanese.AmazonNotes.Gamification;
                this.releaseNotes.AmazonNotes.Coaching =
                    this.releaseNotesLocal.Japanese.AmazonNotes.Coaching;
                this.releaseNotes.AmazonNotes.QA =
                    this.releaseNotesLocal.Japanese.AmazonNotes.QA;
                this.releaseNotes.AmazonNotes.Dashboards =
                    this.releaseNotesLocal.Japanese.AmazonNotes.Dashboards;
                this.releaseNotes.AmazonNotes.Wallboards =
                    this.releaseNotesLocal.Japanese.AmazonNotes.Wallboards;
                //Avaya
                this.releaseNotes.AvayaNotes.General =
                    this.releaseNotesLocal.Japanese.AvayaNotes.General;
                this.releaseNotes.AvayaNotes.Messaging =
                    this.releaseNotesLocal.Japanese.AvayaNotes.Messaging;
                this.releaseNotes.AvayaNotes.Gamification =
                    this.releaseNotesLocal.Japanese.AvayaNotes.Gamification;
                this.releaseNotes.AvayaNotes.Coaching =
                    this.releaseNotesLocal.Japanese.AvayaNotes.Coaching;
                this.releaseNotes.AvayaNotes.QA =
                    this.releaseNotesLocal.Japanese.AvayaNotes.QA;
                this.releaseNotes.AvayaNotes.Dashboards =
                    this.releaseNotesLocal.Japanese.AvayaNotes.Dashboards;
                this.releaseNotes.AvayaNotes.Wallboards =
                    this.releaseNotesLocal.Japanese.AvayaNotes.Wallboards;
                //UJet
                this.releaseNotes.UJetNotes.General =
                    this.releaseNotesLocal.Japanese.UJetNotes.General;
                this.releaseNotes.UJetNotes.Messaging =
                    this.releaseNotesLocal.Japanese.UJetNotes.Messaging;
                this.releaseNotes.UJetNotes.Gamification =
                    this.releaseNotesLocal.Japanese.UJetNotes.Gamification;
                this.releaseNotes.UJetNotes.Coaching =
                    this.releaseNotesLocal.Japanese.UJetNotes.Coaching;
                this.releaseNotes.UJetNotes.QA =
                    this.releaseNotesLocal.Japanese.UJetNotes.QA;
                this.releaseNotes.UJetNotes.Dashboards =
                    this.releaseNotesLocal.Japanese.UJetNotes.Dashboards;
                this.releaseNotes.UJetNotes.Wallboards =
                    this.releaseNotesLocal.Japanese.UJetNotes.Wallboards;
                break;
        }
        //get partnerId and add partner specific notes for each package
        switch (response) {
            case 0:
                partnerId = "Direct";
                break;
            case 1:
                partnerId = "Nice_inContact";
                break;
            case 2:
                partnerId = "Five9";
                break;
            case 3:
                partnerId = "Serenova";
                break;
            case 4:
                partnerId = "Genesys";
                break;
            case 5:
                partnerId = "Cisco";
                break;
            case 6:
                partnerId = "Amazon";
                break;
            case 7:
                partnerId = "Avaya";
                break;
            case 8:
                partnerId = "UJet";
                break;
            default:
                break;
        }
        this.partnerName = partnerId;
        switch (partnerId) {
            case "Direct":
                this.releaseNotes.Notes.General.concat(
                    this.releaseNotes.DirectNotes.General)
                (this.releaseNotes.Notes.General =
                    this.releaseNotes.Notes.General.concat(
                        this.releaseNotes.DirectNotes.General
                    )),
                    (this.releaseNotes.Notes.Messaging =
                        this.releaseNotes.Notes.Messaging.concat(
                            this.releaseNotes.DirectNotes.Messaging
                        )),
                    (this.releaseNotes.Notes.Gamification =
                        this.releaseNotes.Notes.Gamification.concat(
                            this.releaseNotes.DirectNotes.Gamification
                        )),
                    (this.releaseNotes.Notes.Coaching =
                        this.releaseNotes.Notes.Coaching.concat(
                            this.releaseNotes.DirectNotes.Coaching
                        )),
                    (this.releaseNotes.Notes.QA =
                        this.releaseNotes.Notes.QA.concat(
                            this.releaseNotes.DirectNotes.QA
                        )),
                    (this.releaseNotes.Notes.Dashboards =
                        this.releaseNotes.Notes.Dashboards.concat(
                            this.releaseNotes.DirectNotes.Dashboards
                        )),
                    (this.releaseNotes.Notes.Wallboards =
                        this.releaseNotes.Notes.Wallboards.concat(
                            this.releaseNotes.DirectNotes.Wallboards
                        ));
                break;
            case "Nice_inContact":
                (this.releaseNotes.Notes.General =
                    this.releaseNotes.Notes.General.concat(
                        this.releaseNotes.NiceInContactNotes.General
                    )),
                    (this.releaseNotes.Notes.Messaging =
                        this.releaseNotes.Notes.Messaging.concat(
                            this.releaseNotes.NiceInContactNotes.Messaging
                        )),
                    (this.releaseNotes.Notes.Gamification =
                        this.releaseNotes.Notes.Gamification.concat(
                            this.releaseNotes.NiceInContactNotes.Gamification
                        )),
                    (this.releaseNotes.Notes.Coaching =
                        this.releaseNotes.Notes.Coaching.concat(
                            this.releaseNotes.NiceInContactNotes.Coaching
                        )),
                    (this.releaseNotes.Notes.QA =
                        this.releaseNotes.Notes.QA.concat(
                            this.releaseNotes.NiceInContactNotes.QA
                        )),
                    (this.releaseNotes.Notes.Dashboards =
                        this.releaseNotes.Notes.Dashboards.concat(
                            this.releaseNotes.NiceInContactNotes.Dashboards
                        )),
                    (this.releaseNotes.Notes.Wallboards =
                        this.releaseNotes.Notes.Wallboards.concat(
                            this.releaseNotes.NiceInContactNotes.Wallboards
                        ));
                break;
            case "Five9":
                (this.releaseNotes.Notes.General =
                    this.releaseNotes.Notes.General.concat(
                        this.releaseNotes.Five9Notes.General
                    )),
                    (this.releaseNotes.Notes.Messaging =
                        this.releaseNotes.Notes.Messaging.concat(
                            this.releaseNotes.Five9Notes.Messaging
                        )),
                    (this.releaseNotes.Notes.Gamification =
                        this.releaseNotes.Notes.Gamification.concat(
                            this.releaseNotes.Five9Notes.Gamification
                        )),
                    (this.releaseNotes.Notes.Coaching =
                        this.releaseNotes.Notes.Coaching.concat(
                            this.releaseNotes.Five9Notes.Coaching
                        )),
                    (this.releaseNotes.Notes.QA =
                        this.releaseNotes.Notes.QA.concat(
                            this.releaseNotes.Five9Notes.QA
                        )),
                    (this.releaseNotes.Notes.Dashboards =
                        this.releaseNotes.Notes.Dashboards.concat(
                            this.releaseNotes.Five9Notes.Dashboards
                        )),
                    (this.releaseNotes.Notes.Wallboards =
                        this.releaseNotes.Notes.Wallboards.concat(
                            this.releaseNotes.Five9Notes.Wallboards
                        ));
                break;
            case "Serenova":
                (this.releaseNotes.Notes.General =
                    this.releaseNotes.Notes.General.concat(
                        this.releaseNotes.SerenovaNotes.General
                    )),
                    (this.releaseNotes.Notes.Messaging =
                        this.releaseNotes.Notes.Messaging.concat(
                            this.releaseNotes.SerenovaNotes.Messaging
                        )),
                    (this.releaseNotes.Notes.Gamification =
                        this.releaseNotes.Notes.Gamification.concat(
                            this.releaseNotes.SerenovaNotes.Gamification
                        )),
                    (this.releaseNotes.Notes.Coaching =
                        this.releaseNotes.Notes.Coaching.concat(
                            this.releaseNotes.SerenovaNotes.Coaching
                        )),
                    (this.releaseNotes.Notes.QA =
                        this.releaseNotes.Notes.QA.concat(
                            this.releaseNotes.SerenovaNotes.QA
                        )),
                    (this.releaseNotes.Notes.Dashboards =
                        this.releaseNotes.Notes.Dashboards.concat(
                            this.releaseNotes.SerenovaNotes.Dashboards
                        )),
                    (this.releaseNotes.Notes.Wallboards =
                        this.releaseNotes.Notes.Wallboards.concat(
                            this.releaseNotes.SerenovaNotes.Wallboards
                        ));
                break;
            case "Genesys":
                (this.releaseNotes.Notes.General =
                    this.releaseNotes.Notes.General.concat(
                        this.releaseNotes.GenesysNotes.General
                    )),
                    (this.releaseNotes.Notes.Messaging =
                        this.releaseNotes.Notes.Messaging.concat(
                            this.releaseNotes.GenesysNotes.Messaging
                        )),
                    (this.releaseNotes.Notes.Gamification =
                        this.releaseNotes.Notes.Gamification.concat(
                            this.releaseNotes.GenesysNotes.Gamification
                        )),
                    (this.releaseNotes.Notes.Coaching =
                        this.releaseNotes.Notes.Coaching.concat(
                            this.releaseNotes.GenesysNotes.Coaching
                        )),
                    (this.releaseNotes.Notes.QA =
                        this.releaseNotes.Notes.QA.concat(
                            this.releaseNotes.GenesysNotes.QA
                        )),
                    (this.releaseNotes.Notes.Dashboards =
                        this.releaseNotes.Notes.Dashboards.concat(
                            this.releaseNotes.GenesysNotes.Dashboards
                        )),
                    (this.releaseNotes.Notes.Wallboards =
                        this.releaseNotes.Notes.Wallboards.concat(
                            this.releaseNotes.GenesysNotes.Wallboards
                        ));
                break;
            case "Cisco":
                (this.releaseNotes.Notes.General =
                    this.releaseNotes.Notes.General.concat(
                        this.releaseNotes.CiscoNotes.General
                    )),
                    (this.releaseNotes.Notes.Messaging =
                        this.releaseNotes.Notes.Messaging.concat(
                            this.releaseNotes.CiscoNotes.Messaging
                        )),
                    (this.releaseNotes.Notes.Gamification =
                        this.releaseNotes.Notes.Gamification.concat(
                            this.releaseNotes.CiscoNotes.Gamification
                        )),
                    (this.releaseNotes.Notes.Coaching =
                        this.releaseNotes.Notes.Coaching.concat(
                            this.releaseNotes.CiscoNotes.Coaching
                        )),
                    (this.releaseNotes.Notes.QA =
                        this.releaseNotes.Notes.QA.concat(
                            this.releaseNotes.CiscoNotes.QA
                        )),
                    (this.releaseNotes.Notes.Dashboards =
                        this.releaseNotes.Notes.Dashboards.concat(
                            this.releaseNotes.CiscoNotes.Dashboards
                        )),
                    (this.releaseNotes.Notes.Wallboards =
                        this.releaseNotes.Notes.Wallboards.concat(
                            this.releaseNotes.CiscoNotes.Wallboards
                        ));
                break;
            case "Amazon":
                (this.releaseNotes.Notes.General =
                    this.releaseNotes.Notes.General.concat(
                        this.releaseNotes.AmazonNotes.General
                    )),
                    (this.releaseNotes.Notes.Messaging =
                        this.releaseNotes.Notes.Messaging.concat(
                            this.releaseNotes.AmazonNotes.Messaging
                        )),
                    (this.releaseNotes.Notes.Gamification =
                        this.releaseNotes.Notes.Gamification.concat(
                            this.releaseNotes.AmazonNotes.Gamification
                        )),
                    (this.releaseNotes.Notes.Coaching =
                        this.releaseNotes.Notes.Coaching.concat(
                            this.releaseNotes.AmazonNotes.Coaching
                        )),
                    (this.releaseNotes.Notes.QA =
                        this.releaseNotes.Notes.QA.concat(
                            this.releaseNotes.AmazonNotes.QA
                        )),
                    (this.releaseNotes.Notes.Dashboards =
                        this.releaseNotes.Notes.Dashboards.concat(
                            this.releaseNotes.AmazonNotes.Dashboards
                        )),
                    (this.releaseNotes.Notes.Wallboards =
                        this.releaseNotes.Notes.Wallboards.concat(
                            this.releaseNotes.AmazonNotes.Wallboards
                        ));
                break;
            case "Avaya":
                (this.releaseNotes.Notes.General =
                    this.releaseNotes.Notes.General.concat(
                        this.releaseNotes.AvayaNotes.General
                    )),
                    (this.releaseNotes.Notes.Messaging =
                        this.releaseNotes.Notes.Messaging.concat(
                            this.releaseNotes.AvayaNotes.Messaging
                        )),
                    (this.releaseNotes.Notes.Gamification =
                        this.releaseNotes.Notes.Gamification.concat(
                            this.releaseNotes.AvayaNotes.Gamification
                        )),
                    (this.releaseNotes.Notes.Coaching =
                        this.releaseNotes.Notes.Coaching.concat(
                            this.releaseNotes.AvayaNotes.Coaching
                        )),
                    (this.releaseNotes.Notes.QA =
                        this.releaseNotes.Notes.QA.concat(
                            this.releaseNotes.AvayaNotes.QA
                        )),
                    (this.releaseNotes.Notes.Dashboards =
                        this.releaseNotes.Notes.Dashboards.concat(
                            this.releaseNotes.AvayaNotes.Dashboards
                        )),
                    (this.releaseNotes.Notes.Wallboards =
                        this.releaseNotes.Notes.Wallboards.concat(
                            this.releaseNotes.AvayaNotes.Wallboards
                        ));
                break;
            case "UJet":
                (this.releaseNotes.Notes.General =
                    this.releaseNotes.Notes.General.concat(
                        this.releaseNotes.UJetNotes.General
                    )),
                    (this.releaseNotes.Notes.Messaging =
                        this.releaseNotes.Notes.Messaging.concat(
                            this.releaseNotes.UJetNotes.Messaging
                        )),
                    (this.releaseNotes.Notes.Gamification =
                        this.releaseNotes.Notes.Gamification.concat(
                            this.releaseNotes.UJetNotes.Gamification
                        )),
                    (this.releaseNotes.Notes.Coaching =
                        this.releaseNotes.Notes.Coaching.concat(
                            this.releaseNotes.UJetNotes.Coaching
                        )),
                    (this.releaseNotes.Notes.QA =
                        this.releaseNotes.Notes.QA.concat(
                            this.releaseNotes.UJetNotes.QA
                        )),
                    (this.releaseNotes.Notes.Dashboards =
                        this.releaseNotes.Notes.Dashboards.concat(
                            this.releaseNotes.UJetNotes.Dashboards
                        )),
                    (this.releaseNotes.Notes.Wallboards =
                        this.releaseNotes.Notes.Wallboards.concat(
                            this.releaseNotes.UJetNotes.Wallboards
                        ));
                break;
            default:
                break;
        }
        await this.partnerPackage(); //filter packages after partner specific notes are added
        this.localizePackageHeaders(userLang);
    }

    /*async getNotificationId() {
        let notificationSource = await this.releaseModalService.notificationID()
        let notificationReference = notificationSource.find(n => n !== null && n.NotificationSource.match('releaseNotes') && n.ShowOnLogin == false && n.Viewed !== false);
        if(notificationReference) {
            this.notificationName = notificationReference.NotificationSource;
            this.showNotification = notificationReference.ShowOnLogin;
            this.viewedNotification = notificationReference.Viewed;
        }
    }*/

    dismiss() {
        this.modalService.dismissAll(this.releaseNotesModal);
        this.notification.dismiss();
    }

    //set parameters and opens release modal
    async openReleaseModal(releaseNotesModal: TemplateRef<any>) {
        //await this.getNotificationId();
        if (
            this.showNotification !== false &&
            this.notificationName === "releaseNotes"
        ) {
            this.modalService.open(releaseNotesModal, {
                scrollable: true,
                size: "xl",
                centered: true,
                backdropClass: "release-modal-backdrop",
                windowClass: "release-modal-window",
            });
        }
    }

    ngOnInit() {
        this.stringifiedReleaseData = JSON.stringify(this.releaseNotes);
        this.parsedJson = JSON.parse(this.stringifiedReleaseData);
        this.stringifiedReleaseDataLocal = JSON.stringify(
            this.releaseNotesLocal
        );
        this.parsedJsonLocal = JSON.parse(this.stringifiedReleaseDataLocal);
        this.partnerPackage();
        this.showPartnerPackages();
        //this.getNotificationId()
    }

    ngOnChanges(changes: SimpleChanges): void {
        //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
        //Add '${implements OnChanges}' to the class.
        if (changes.notification.currentValue) {
            this.notificationName = this.notification.source;
            this.showNotification = this.notification.showOnLogin;
            this.openReleaseModal(this.releaseNotesModal);
        }
    }
    ngAfterViewInit() {
        //this.openReleaseModal(this.releaseNotesModal);
    }

    private localizePackageHeaders(language: string): void {
        let langMap: any;
        switch (language) {
            case "Español":
                langMap = this.releaseNotesLocal.Spanish;
                break;
            case "Français":
                langMap = this.releaseNotesLocal.French;
                break;
            case "Deutsch":
                langMap = this.releaseNotesLocal.German;
                break;
            case "Français Canadien":
                langMap = this.releaseNotesLocal.CanadianFrench;
                break;
            case "Portugues do Brasil":
                langMap = this.releaseNotesLocal.BrazilianPortuguese;
                break;
            case "Nederlands":
                langMap = this.releaseNotesLocal.Dutch;
                break;
            case "Japanese":
                langMap = this.releaseNotesLocal.Japanese;
                break;
            default:
                return;
        }
        for (let i = 0; i < this.packageFilter.length; i++) {
            switch (this.packageFilter[i]) {
                case "General":
                    this.packageFilter[i] = langMap.General;
                    break;
                case "Messaging":
                    this.packageFilter[i] = langMap.Messaging;
                    break;
                case "Gamification":
                    this.packageFilter[i] = langMap.Gamification;
                    break;
                case "Coaching":
                    this.packageFilter[i] = langMap.Coaching;
                    break;
                case "QA":
                    this.packageFilter[i] = langMap.QA;
                    break;
                case "Dashboards":
                    this.packageFilter[i] = langMap.Dashboards;
                    break;
                case "Wallboards":
                    this.packageFilter[i] = langMap.Wallboards;
                    break;
            }
        }
    }
}
